import { Instance as TinyColor } from 'tinycolor2'
import { makeStyles } from 'tss-react/mui'
import { darkBg } from '../../../assets/colors'

const useStyles = makeStyles<{color: TinyColor}>()((theme, params) => ({
    root: {
        color: '#007bff',
        height: 10,
        padding: '0 5px',
        width: 'calc(100% - 18px)',
        margin: '0 4px',

        '& .MuiSlider-thumb': {
            height: 10,
            width: 10,
            backgroundColor: theme.palette.mode === "dark" ? darkBg:'#fff',
            boxShadow: 'none',
            borderRadius: "50%",
            overflow: 'hidden',
            border: `1px solid ${theme.palette.mode === "dark" ? '#fff': darkBg}`,

            '&:focus, &:hover, &.Mui-active': {
                boxShadow: 'none',
            },
        },
        '& .MuiSlider-valueLabel': {
            fontSize: 12,
            fontWeight: 'normal',
            top: -6,
            backgroundColor: 'unset',
            color: theme.palette.text.primary,
            '&::before': {
                display: 'none',
            },
            '& *': {
                background: 'transparent',
                color: '#000',
            },
        },
        '& .MuiSlider-track': {
            border: 'none',
            height: 10,
            background: 'none'
        },
        '& .MuiSlider-rail': {
            opacity: 1,
            background: `linear-gradient(90deg, transparent, ${params.color.toRgbString()})`,
            border: `1px solid ${params.color.toRgbString()}`,
            left: '-5px',
            right: '-5px',
            width: 'unset'
        }
    }
}))

export default useStyles